import { Component } from '@angular/core';
import { IconComponent } from '@kin/spark-ui';

@Component({
  selector: 'app-error',
  standalone: true,
  imports: [IconComponent],
  templateUrl: './error.component.html',
  styleUrl: './error.component.css',
})
export class ErrorComponent {}
